import { Flex } from 'roo-ui/components';
import { CardProps } from '../types';
import {
  CardWrapper,
  CardImage,
  InfoWrapper,
  Heading,
  SubHeading,
  StayInfo,
  BookingStatus,
  CancellationLabel,
  DepositPayReminder,
  Hr,
  ItemLinks,
} from '../Components';
import { generateViewBookingDetailsItemLink, generateActionItemLinks } from './helpers';

const UpcomingBookingCard = ({ booking, ...rest }: CardProps) => {
  const {
    image,
    reservation: { property },
  } = booking;
  const detailsLink = generateViewBookingDetailsItemLink(booking);
  const itemLinks = generateActionItemLinks(booking);

  return (
    <CardWrapper>
      <CardImage {...image} link={detailsLink} />

      <InfoWrapper bookingId={booking.id} {...rest}>
        <BookingStatus booking={booking} />

        <Heading>{property.name}</Heading>
        <SubHeading>{property.address.suburb}</SubHeading>

        <StayInfo booking={booking} />

        <Flex flexDirection={['column', 'row']} mb={[0, 4]}>
          <CancellationLabel booking={booking} />
          <DepositPayReminder booking={booking} />
        </Flex>
      </InfoWrapper>
      <Hr />
      <ItemLinks links={itemLinks} />
    </CardWrapper>
  );
};

UpcomingBookingCard.displayName = 'UpcomingBookingCard';

export { UpcomingBookingCard };
